var _mask, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPaymentOnHold = function SvgIconPaymentOnHold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 110 120"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "Icon_PaymentOnHold_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.906 31.722c5.348 0 9.577 4.352 9.577 9.576v38.804c0 5.223-4.23 9.576-9.577 9.576H24.094c-5.223 0-9.576-4.229-9.576-9.576V41.298c0-5.224 4.353-9.576 9.576-9.576zM77.47 79.983a1.884 1.884 0 0 0 0 3.769h8.795a1.885 1.885 0 0 0 0-3.769zM16.383 45.651a1.865 1.865 0 1 0 0 3.73h77.234a1.866 1.866 0 1 0 0-3.73z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Icon_PaymentOnHold_svg__a)",
    d: "M85.906 31.722c5.348 0 9.577 4.352 9.577 9.576v38.804c0 5.223-4.23 9.576-9.577 9.576H24.094c-5.223 0-9.576-4.229-9.576-9.576V41.298c0-5.224 4.353-9.576 9.576-9.576zM77.47 79.983a1.884 1.884 0 0 0 0 3.769h8.795a1.885 1.885 0 0 0 0-3.769zM16.383 45.651a1.865 1.865 0 1 0 0 3.73h77.234a1.866 1.866 0 1 0 0-3.73z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Icon_PaymentOnHold_svg__b)",
    d: "M95.483 41.298h1zm0 38.804h1zm-71.389 9.576v1zm-9.576-9.576h-1zm0-38.804h-1zm9.576-9.576v-1zM77.47 79.983v-1zm-1.884 1.884h-1zm1.884 1.885v1zm10.68-1.885h1zM16.383 45.651v-1zm-1.865 1.865h-1zm1.865 1.866v1zm79.1-1.865h1zm-9.577-15.795v1c4.787 0 8.577 3.896 8.577 8.576h2c0-5.768-4.669-10.576-10.577-10.576zm9.577 9.576h-1v38.804h2V41.298zm0 38.804h-1c0 4.679-3.79 8.576-8.577 8.576v2c5.908 0 10.577-4.81 10.577-10.576zm-9.577 9.576v-1H24.094v2h61.812zm-61.812 0v-1c-4.68 0-8.576-3.79-8.576-8.576h-2c0 5.908 4.809 10.576 10.576 10.576zm-9.576-9.576h1V41.298h-2v38.804zm0-38.804h1c0-4.671 3.905-8.576 8.576-8.576v-2c-5.775 0-10.576 4.8-10.576 10.576zm9.576-9.576v1h61.812v-2H24.094zM77.47 79.983v-1a2.884 2.884 0 0 0-2.884 2.884h2c0-.488.396-.884.884-.884zm-1.884 1.884h-1a2.884 2.884 0 0 0 2.884 2.885v-2a.884.884 0 0 1-.884-.885zm1.884 1.885v1h8.795v-2H77.47zm8.795 0v1a2.885 2.885 0 0 0 2.885-2.885h-2a.885.885 0 0 1-.885.885zm1.885-1.885h1a2.884 2.884 0 0 0-2.885-2.884v2c.489 0 .885.396.885.884zm-1.885-1.884v-1H77.47v2h8.795zM16.383 45.651v-1a2.865 2.865 0 0 0-2.865 2.865h2c0-.477.387-.865.865-.865zm-1.865 1.865h-1a2.865 2.865 0 0 0 2.865 2.866v-2a.865.865 0 0 1-.865-.865zm1.865 1.866v1h77.234v-2H16.383zm77.234 0v1a2.866 2.866 0 0 0 2.866-2.865h-2a.866.866 0 0 1-.866.865zm1.866-1.865h1a2.866 2.866 0 0 0-2.866-2.866v2c.478 0 .866.388.866.865zm-1.866-1.866v-1H16.383v2h77.234z",
    mask: "url(#Icon_PaymentOnHold_svg__c)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0D4056",
    d: "M55.584 78.41c-6.07.324-11.279-4.421-11.607-10.578a11.22 11.22 0 0 1 3.534-8.822 1.44 1.44 0 0 1 2.035.07c.54.58.511 1.49-.07 2.034a8.35 8.35 0 0 0-2.626 6.565c.243 4.572 4.095 8.098 8.581 7.858 4.486-.239 7.941-4.154 7.697-8.726a1.437 1.437 0 0 1 1.36-1.513 1.437 1.437 0 0 1 1.513 1.36c.328 6.157-4.346 11.429-10.417 11.752"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Icon_PaymentOnHold_svg__d)",
    d: "M55.584 78.41c-6.07.324-11.279-4.421-11.607-10.578a11.22 11.22 0 0 1 3.534-8.822 1.44 1.44 0 0 1 2.035.07c.54.58.511 1.49-.07 2.034a8.35 8.35 0 0 0-2.626 6.565c.243 4.572 4.095 8.098 8.581 7.858 4.486-.239 7.941-4.154 7.697-8.726a1.437 1.437 0 0 1 1.36-1.513 1.437 1.437 0 0 1 1.513 1.36c.328 6.157-4.346 11.429-10.417 11.752"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M55.004 56c6.08 0 11.028 5.015 11.028 11.181a11.22 11.22 0 0 1-3.999 8.621 1.44 1.44 0 0 1-2.028-.177 1.443 1.443 0 0 1 .177-2.028 8.35 8.35 0 0 0 2.973-6.416c0-4.579-3.658-8.304-8.151-8.304s-8.151 3.725-8.151 8.304c0 .796-.642 1.439-1.438 1.439a1.437 1.437 0 0 1-1.439-1.439C43.976 61.015 48.924 56 55.004 56"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Icon_PaymentOnHold_svg__a",
    x1: 55.001,
    x2: 55.001,
    y1: 89.678,
    y2: -8.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#004761"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Icon_PaymentOnHold_svg__b",
    x1: 55.001,
    x2: 55.001,
    y1: 31.722,
    y2: 89.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.087,
    stopColor: "#00C499",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Icon_PaymentOnHold_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.60298 11.31254 -12.38871 .66034 55.744 78.402)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C59A",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C499",
    stopOpacity: 0
  })))));
};
export default SvgIconPaymentOnHold;